<div class="div-notification {{ className }} {{ animation }}" *ngIf="notification.show">
  <div class="div-img">
    <img alt="icon-message" src="{{ image }}">
  </div>
  <div class="div-text">
    <h1>{{ notification.title | translatePipe }}</h1>
    <p>{{ notification.message | translatePipe }}</p>
  </div>
</div>
